import { Search, SlidersHorizontal } from "lucide-react";
import { LEARN } from "@/constants/testIds";

const LENGTHS = [{ v: "all", l: "Any" }, { v: "short", l: "≤ 5 min" }, { v: "medium", l: "6–8 min" }, { v: "long", l: "9+ min" }];
const STATUSES = [{ v: "all", l: "Any" }, { v: "not_started", l: "Not started" }, { v: "completed", l: "Completed" }, { v: "saved", l: "Saved" }];

export function FiltersToolbar({ query, setQuery, showFilters, setShowFilters, lengthF, setLengthF, statusF, setStatusF }) {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <div className="flex-1 relative">
          <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#291B2D]/40" />
          <input value={query} onChange={(e) => setQuery(e.target.value)} data-testid={LEARN.searchInput}
            placeholder="Search lessons — confidence, boundaries, rest…"
            className="w-full bg-white border border-[#291B2D]/10 rounded-full pl-11 pr-4 py-3 outline-none focus:ring-2 focus:ring-[#C89B55] text-sm lg:text-base" />
        </div>
        <button onClick={() => setShowFilters((s) => !s)} data-testid="learn-filter-toggle"
          className={`inline-flex items-center gap-2 rounded-full px-4 py-3 text-sm ${showFilters ? "bg-[#291B2D] text-white" : "bg-white border border-[#291B2D]/10"}`}>
          <SlidersHorizontal size={14} /> Filters
        </button>
      </div>
      {showFilters && (
        <div className="bg-white rounded-3xl p-6 card-soft space-y-5" data-testid="learn-filter-panel">
          <div>
            <p className="text-xs uppercase tracking-widest text-[#291B2D]/50 font-semibold mb-3">Length</p>
            <div className="flex flex-wrap gap-2">
              {LENGTHS.map((o) => (
                <button key={o.v} onClick={() => setLengthF(o.v)} data-testid={`f-len-${o.v}`}
                  className={`text-sm px-4 py-2 rounded-full ${lengthF === o.v ? "bg-[#291B2D] text-white" : "bg-[#F7F2EA]"}`}>{o.l}</button>
              ))}
            </div>
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-[#291B2D]/50 font-semibold mb-3">Progress</p>
            <div className="flex flex-wrap gap-2">
              {STATUSES.map((o) => (
                <button key={o.v} onClick={() => setStatusF(o.v)} data-testid={`f-status-${o.v}`}
                  className={`text-sm px-4 py-2 rounded-full ${statusF === o.v ? "bg-[#291B2D] text-white" : "bg-[#F7F2EA]"}`}>{o.l}</button>
              ))}
            </div>
          </div>
          <button onClick={() => { setLengthF("all"); setStatusF("all"); setQuery(""); }}
            className="text-sm text-[#291B2D]/50 hover:text-[#291B2D] underline underline-offset-4">Reset filters</button>
        </div>
      )}
    </div>
  );
}
